import React, { useState } from 'react';
import { Button } from 'antd';
import Countdown from 'antd/lib/statistic/Countdown';
import cx from 'classnames';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'hooks/useAppDispatch';
import {
  resendTwoFactorAuthCode,
  sendCodeActivateTwoFA,
} from 'redux/reducers/accountSlice';
import { TwoFactorAuthSendMessageTypeEnum } from 'api/backofficeApiClient';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';

import styles from './ButtonWithTimer.module.less';

type Props = {
  authCode?: string;
  type?: TwoFactorAuthSendMessageTypeEnum;
};

export default function ButtonWithTimer(props: Props) {
  const { authCode, type } = props;
  const [timerValue, setTimerValue] = useState<number>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const turnOnTimer = () => {
    setTimerValue(Date.now() + 30000);
  };

  const turnOffTimer = () => {
    setTimerValue(undefined);
  };

  const handleResendCode = async () => {
    let requestData: any;
    let correctAction: any;

    switch (type) {
      case TwoFactorAuthSendMessageTypeEnum.EnableTwoFactorAuth:
        correctAction = sendCodeActivateTwoFA;
        requestData = TwoFactorAuthSendMessageTypeEnum.EnableTwoFactorAuth;
        break;
      case TwoFactorAuthSendMessageTypeEnum.ResetPassword:
        correctAction = sendCodeActivateTwoFA;
        requestData = TwoFactorAuthSendMessageTypeEnum.ResetPassword;
        break;
      default:
        correctAction = resendTwoFactorAuthCode;
        requestData = authCode;
    }

    const result = await dispatch(correctAction(requestData));

    if (correctAction.fulfilled.match(result)) {
      turnOnTimer();

      if (result.payload?.authCode) {
        navigate('/login', {
          replace: true,
          state: { uid: result.payload.authCode },
        });
      }
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <>
      {timerValue && (
        <div className={styles.newCode}>
          <i className="icon icon-check-filled" />
          <div className={styles.newCodeText}>New code sent</div>
        </div>
      )}
      <Button
        onClick={handleResendCode}
        disabled={Boolean(timerValue)}
        className={cx(styles.timerBtn, 'ant-btn-link borderless-btn icon-btn')}
      >
        <i className="icon icon-resend" />
        <div className={styles.timerBtnText}>Resend</div>

        {timerValue && (
          <Countdown
            format="ss"
            value={timerValue}
            onFinish={turnOffTimer}
            prefix={<span>(</span>}
            suffix={<span>)</span>}
          />
        )}
      </Button>
    </>
  );
}
